import React from 'react';

export default function CustomUploadButtonColor({
  id,
  title,
  onChange,
  accept = "image/*",
  color = "white",
  bgColor = "black",
  borderRadius = "10px",
  borderColor = "#000",
  width = "160px",
  height = "40px"
}) {
  return (
    <label
      htmlFor={id}
      className="custom-upload-button"
      style={{
        backgroundColor: bgColor,
        color: color,
        borderRadius: borderRadius,
        border: `1px solid ${borderColor}`,
        width: width,
        height: height,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        fontWeight: '500',
        marginTop: '10px',
        marginBottom: '10px'
      }}
    >
      {title}
      <input
        id={id}
        type="file"
        accept={accept}
        onChange={onChange}
        style={{ display: 'none' }}
      />
    </label>
  );
}